<template>
  <div class="card my-3 px-3 py-3">
    <h5 style="color: #000; align-self: center">{{ title }}</h5>
    <apexchart type="bar" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: ['title', 'values', 'categories'],
  data: function() {
    return {
      chartOptions: {
        chart: {
          id: "barchart",
          toolbar: {
            show: false,
          },
          type: 'bar',
          stacked: true,
          stackType: '100%'
        },
        colors: ['#F2A687', '#daa520', '#90ee90', '#27ae60'], // Ruim, Regular, Bom, Ótimo
        fill: {
          colors: ['#F2A687', '#daa520', '#90ee90', '#27ae60']
        },
        dataLabels: {
          style: {
            colors: ['#8b0000', '#b8860b', '#006400', '#004d26']
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: 50,
            columnWidth: '60%',
          }
        },
        theme: {
          palette: "palette7",
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: this.categories,
          labels: {
            show: false
          }
        },
        tooltip: {
          theme: 'dark',
        },
        yaxis: {
          show: true,
          labels: {
            fontWeight: '600'
          }
        },
        legend: {
          position: 'bottom'
        }
      },
      series: this.values
    };
  }
};
</script>
